// Path: src\Components\Common\JoinViaCodeTeamRegistration.jsx
import { React, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import TextInput from "../CommonFields/TextInput";
import BaseHome from "../Home/BaseHome";
import india from "../../images/india.png";
import { TextField, IconButton, InputAdornment } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import AddIcon from "@mui/icons-material/Add";
import { userByPhone } from "../../api/auth.api";
import { contestJoin } from "../../api/contest.api";
import { tournamentJoin } from "../../api/tournament.api";
import { useNavigate } from "react-router";
import { useProfileDataContext } from "../ProfileContext/ProfileContext";
import { toastSuccess, toastError } from "../../Utilities/toast";
import NonPremiumMaxJoinPopup from "./NonPremiumMaxJoin";
import { scrimJoin } from "../../api/scrim.api";

const TeamRegistration = () => {
  const [mobileNumber, setMobileNumber] = useState("");
  const [PlayerMobileNumber, setPlayerMobileNumber] = useState("");
  const [inGameName, setInGameName] = useState("");
  const [inGameName1, setInGameName1] = useState("");
  const [isPlayerAdded, setIsPlayerAdded] = useState(false);
  const [errorMessage, setErrorMessage] = useState(""); // State for error message
  const [registerDataInfo, setRegisterData] = useState("");
  const navigate = useNavigate();
  const { fetchAccountProfile } = useProfileDataContext();
  const [isSubscriptionPopup, setSubscriptionPop] = useState(false);
  const [isDisableJoinBtn, setIsDisableJoinBtn] = useState(false);

  const { t } = useTranslation();

  let noOfPlayer = JSON?.parse(localStorage?.getItem('registerData'))?.players || 0
  let noOfExtraPlayer = JSON?.parse(localStorage?.getItem('registerData'))?.extraPlayers || 0

  let newArray = [];
  for (let i = 0; i < noOfPlayer - 1; i++) {
    newArray.push({
      countryCode: "+91",
      phoneNo: "",
      inNameGame: "",
      isSubmit: false,
      isOptional: false,
      userId: "",
      phoneNoError: "",
      gamerjiName: "",
      email: ""
    });
  }

  for (let i = 0; i < noOfExtraPlayer; i++) {
    newArray.push({
      countryCode: "+91",
      phoneNo: "",
      inNameGame: "",
      isSubmit: false,
      isOptional: true,
      userId: "",
      phoneNoError: "",
      gamerjiName: "",
      email: ""
    });
  }

  const [frmInitialValues, setFrmInitialValues] = useState(newArray);

  useEffect(() => {
    let registerData = JSON?.parse(localStorage?.getItem('registerData'))
    if (!registerData) {
      navigate(-1);
    }
    setRegisterData(registerData);
  }, [])

  useEffect(() => {
    if (registerDataInfo?.contest) {
      localStorage?.removeItem('registerData')
    }
  }, [registerDataInfo])

  const handleClear = (index) => {
    let formdata = [...frmInitialValues];
    let fromdataobj = { ...formdata[index] };
    fromdataobj.inNameGame = "";
    fromdataobj.userId = "";
    fromdataobj.phoneNo = "";
    fromdataobj.isSubmit = false;
    fromdataobj.phoneNoError = "";
    fromdataobj.gamerjiName = "";
    fromdataobj.email = "";
    formdata[index] = fromdataobj;
    setFrmInitialValues(formdata);
  };

  let checkMobileWithTeam = (number, ind) => {
    let index = frmInitialValues.findIndex(
      (obj, i) => obj?.phoneNo == number && i !== ind
    );
    if (index > -1) {
      return true;
    } else {
      return false;
    }
  };

  const handleAddPlayer = async (index) => {
    let formdata = [...frmInitialValues];
    let fromdataobj = { ...formdata[index] };
    if (fromdataobj?.phoneNo == "") {
      fromdataobj.phoneNoError = t("errors.error_please_enter_the_mobile_number");
      formdata[index] = fromdataobj;
      setFrmInitialValues(formdata);
      return;
    }
    else if (fromdataobj?.phoneNo?.length === 0) {
      fromdataobj.phoneNoError = t("errors.error_please_enter_the_mobile_number");
      formdata[index] = fromdataobj;
      setFrmInitialValues(formdata);
      return;
    } else if (fromdataobj?.phoneNo?.length !== 10) {
      fromdataobj.phoneNoError = t("errors.error_please_enter_a_valid_10_digit_mobile_number");
      formdata[index] = fromdataobj;
      setFrmInitialValues(formdata);
      return;
    }

    let checkTeam = checkMobileWithTeam(fromdataobj?.phoneNo, index);
    if (!checkTeam) {
      let payload = {
        search: {
          "game": registerDataInfo?.game,
          "phoneCode": fromdataobj?.countryCode,
          "phone": fromdataobj?.phoneNo
        }
      }

      getUserInGameNameData(payload, index);
    }
    else {
      toastError(t("errors.error_already_added_this_number"));
      return;
    }
  };

  const getUserInGameNameData = async (data, index) => {
    // setLoading(true)
    try {
      const res = await userByPhone(data);
      if (res?.success && res?.data) {
        let formdata = [...frmInitialValues];
        let fromdataobj = { ...formdata[index] };
        fromdataobj.inNameGame = res?.data?.[0]?.userINGameName;
        fromdataobj.gamerjiName = res?.data?.[0]?.gamerjiName;
        fromdataobj.isSubmit = true;
        fromdataobj.userId = res?.data?.[0]?.user;
        fromdataobj.email = res?.data?.[0]?.email;
        formdata[index] = fromdataobj;
        setFrmInitialValues(formdata);
        // setLoading(false)
      }
      else {
        toastError(res?.data?.errors?.[0]?.msg);
      }
    } catch (error) {
      // setLoading(false)

      toastError(error?.response?.data?.errors?.[0]?.msg);
    }
  };

  const handleSave = async (e) => {
    e.preventDefault();
    let errMsg = "";

    frmInitialValues.forEach((euser, index) => {
      index = index + 1;
      if (!euser?.isOptional) {
        if (!euser.phoneNo) {
          errMsg += t('errors.error_please_enter_mobile_number_for_user', { n: index + 1 });
          toastError(t('errors.error_please_enter_mobile_number_for_user', { n: index + 1 }));
          return;
        }
        if (!euser.isSubmit) {
          errMsg += t('errors.error_please_add_user', { n: index + 1 });
          toastError(t('errors.error_please_add_user', { n: index + 1 }));
          return;
        }
        if (!euser.gamerjiName) {
          errMsg += t('errors.error_enter_gamerji_username', { n: index + 1 });
          toastError(t('errors.error_enter_gamerji_username', { n: index + 1 }));
          return;
        }
        if (!euser.inNameGame) {
          errMsg += t('errors.error_please_enter_in_game_name_for_user', { n: index + 1 });
          toastError(t('errors.error_please_enter_in_game_name_for_user', { n: index + 1 }));
          return;
        }
      } else {
        if (euser.phoneNo != "") {
          if (!euser.phoneNo) {
            errMsg += t('errors.error_please_enter_mobile_number_for_user', { n: index + 1 });
            toastError(t('errors.error_please_enter_mobile_number_for_user', { n: index + 1 }));
            return;
          }
          if (!euser.isSubmit) {
            errMsg += t('errors.error_please_add_user', { n: index + 1 });
            toastError(t('errors.error_please_add_user', { n: index + 1 }));
            return;
          }
          if (!euser.gamerjiName) {
            errMsg += t('errors.error_enter_gamerji_username', { n: index + 1 });
            toastError(t('errors.error_enter_gamerji_username', { n: index + 1 }));
            return;
          }
          if (!euser.inNameGame) {
            errMsg += t('errors.error_please_enter_in_game_name_for_user', { n: index + 1 });
            toastError(t('errors.error_please_enter_in_game_name_for_user', { n: index + 1 }));
            return;
          }
        }
      }
    });

    if (errMsg) {
      return false;
    } else {
      setIsDisableJoinBtn(true);
      let players = [];
      frmInitialValues.forEach((euser, index) => {
        if (euser?.phoneNo && euser?.userId) {
          players.push({
            phone: euser?.phoneNo,
            in_game_name: euser?.inNameGame,
            gamerjiName: euser?.gamerjiName,
            user_id: euser?.userId,
            // email: euser?.email
          });
        }
      });

      let data = {};
      if (localStorage?.getItem("registerType") === "contest") {
        data = {
          team: players,
          contest: registerDataInfo?.contest,
          inGameUserName: registerDataInfo?.uniqueIGN,
          teamName: registerDataInfo?.uniqueIGN,
          user: registerDataInfo?.user
        }
        try {
          const res = await contestJoin(data);
          if (res?.success && res?.data) {
            fetchAccountProfile()
            navigate(`/contest/details/${registerDataInfo?.contest}`)
          } else {
            if (res?.data?.errors[0]?.code === "joinUserContests.messages.max_limit_exceed") {
              setSubscriptionPop(true)
            }
            else if(res?.data?.errors[0]?.code==="events.validation.insufficient_balance") {
              toastError(res?.data?.errors?.[0]?.msg);
              setInterval(() => {
                navigate(`/rewards`, { state: { status: 'coinStore' } })
              }, 2000);
            } else {
              setIsDisableJoinBtn(false);
              toastError(res?.data?.errors?.[0]?.msg);
            }
          }
        } catch (error) {
          setIsDisableJoinBtn(false);
          toastError(error);
        }
      } else if (localStorage?.getItem("registerType") === "scrim") {
        var list = [];
         players.map((member) => {
          list.push(
            {
              userId: member?.user_id,
              gamerJiName: member?.gamerjiName,
              inGameName: member?.in_game_name,
              email: member?.user_id,
              mobileNo: member?.user_id,
            }
          )
        })
        let data = {
          scrimId: registerDataInfo?.scrimId,
          usersInGameName: registerDataInfo?.uniqueIGN,
          gamerJiName: JSON.parse(localStorage.getItem("profile"))?.gamerjiName,
          team: list,
          teamName: registerDataInfo?.uniqueIGN,
          mobileNo: JSON.parse(localStorage.getItem("profile"))?.phone
        };
        const res = await scrimJoin(data);
        if (res?.success && res?.data) {
          fetchAccountProfile()
          toastSuccess('Scrim Join Successfully!');
          navigate(`/private-contest/detail/${res?.data?.data?.scrimId}`)
        }
        else {
          if (res?.data?.errors[0]?.code === "joinUserContests.messages.max_limit_exceed") {
            setSubscriptionPop(true)
          } else {console.log(res?.data?.errors)
            setIsDisableJoinBtn(false);
            toastError(res?.data?.errors?.[0]?.msg);
          }
        }
      } else {
        data = {
          team: players,
          user: registerDataInfo?.user,
          inGameUserName: registerDataInfo?.uniqueIGN,
          event: registerDataInfo?.event,
          contest: registerDataInfo?.contest,
          currencyCode: registerDataInfo?.currencyCode,
        }

        try {
          const res = await tournamentJoin(data);
          if (res?.success && res?.data) {
            fetchAccountProfile()
            navigate(`/tournament/details/${registerDataInfo?.event}`)
          } else {
            if (res?.data?.errors[0]?.data === "events.validation.MAX_FREE_TRANSACTION") {
              setSubscriptionPop(true)
            } else {
              setIsDisableJoinBtn(false);
              toastError(res?.data?.errors?.[0]?.msg);
            }
          }
        } catch (error) {
          setIsDisableJoinBtn(false);
          toastError(error);
        }
      }
    }
  };

  const handlePhoneNumberChange = (setter) => (e) => {
    const value = e.target.value;
    // Allow only numbers and restrict length to 10 digits
    if (/^\d*$/.test(value) && value.length <= 10) {
      setter(value);
      // Clear error message if the user starts typing
      if (errorMessage) {
        setErrorMessage(""); // Clear the error message
      }
    }
  };

  return (
    <BaseHome title={t("team_registration.team_registration")} isSaveTeam={true} onBackClick={() => navigate(-1)}>
      <div className="tournament-team-registration-wrapper" style={{paddingBottom:"3rem"}}>
        {/* Captain Info */}
        <div className="tournament-team-registration-caption">
          <div className="col-2 tournament-captain-name">{t("team_registration.captain")}</div>
          <div className="tournament-captain">
            <div className="tournament-captain--wrap">
              {/* <div className="tournament-caption-ingamename">{t("team_registration.in_game_name")}</div> */}
              <div className="tournament-caption-ingamename-textfield">
                <TextInput
                  labelName={t("team_registration.in_game_name")}
                  placeholder={t("team_registration.in_game_name")}
                  defaultValue={registerDataInfo?.uniqueIGN}
                  value={registerDataInfo?.uniqueIGN}
                  readOnly={true}
                />
              </div>
            </div>
          </div>
        </div>

        {frmInitialValues?.length > 0 &&
          frmInitialValues?.map((ele, index) => {
            return (
              <div className="tournament-team-registration-caption">
                <div className={`${ele?.isOptional ? "col-4" : "col-2"} tournament-captain-name f-12 f-11`}>{t("team_registration.player")} {index + 2} {ele?.isOptional && t("team_registration.optional")}</div>
                <div className="tournament-player">
                  <div className="tournament-player-info">
                    <div className="player-info">
                      <div className="player-flag-and-code">
                        <img src={india} alt="Indian Flag" className="flag-icon" />{" "}
                        +91
                      </div>
                      <div className="player-input">
                        <div className="input-container">
                          <TextField
                            variant="outlined"
                            label={t("team_registration.mobile_number")}
                            placeholder={t("validations.enter_mobile_number")}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <IconButton
                                    aria-label={
                                      ele?.isSubmit ? t("team_registration.clear_player") : t("team_registration.add_player")
                                    }
                                    onClick={() => {
                                      if (ele?.isSubmit) {
                                        handleClear(index); // Call handleClear to clear values when cross is clicked
                                      } else {
                                        handleAddPlayer(index); // Call handleAddPlayer to add player when add is clicked
                                      }
                                    }}
                                    edge="end"
                                    className="clear-button"
                                  >
                                    {ele?.isSubmit ? (
                                      <CloseIcon className="color-red" />
                                    ) : (
                                      <AddIcon />
                                    )}
                                  </IconButton>
                                </InputAdornment>
                              ),
                              readOnly: ele?.isSubmit ? true : false,
                              maxLength: 10,
                              minLength: 10
                            }}
                            fullWidth
                            className="phone-input"
                            value={frmInitialValues[
                              index
                            ]?.phoneNo.slice(0, 10)}
                            onChange={(e) => {
                              let formdata = [...frmInitialValues];
                              let fromdataobj = {
                                ...formdata[index],
                              };
                              const digitOnlyRegex = /^\d*$/;
                              if (!digitOnlyRegex.test(e.target.value)) {
                                fromdataobj.phoneNoError = t("errors.error_please_enter_a_valid_10_digit_mobile_number")
                                formdata[index] = fromdataobj;
                                setFrmInitialValues(formdata);
                                return
                              }
                              fromdataobj.phoneNo = e.target.value;
                              fromdataobj.phoneNoError = ""
                              if (e.target.value === "") {
                                fromdataobj.inNameGame = "";
                                fromdataobj.isSubmit = false;
                                fromdataobj.userId = "";
                                fromdataobj.phoneNoError = "";
                                fromdataobj.gamerjiName = "";
                                fromdataobj.email = "";
                              }
                              formdata[index] = fromdataobj;
                              setFrmInitialValues(formdata);
                            }}
                          />
                          {frmInitialValues[
                            index
                          ]?.phoneNoError && (
                              <div
                                className="error-message f-12"
                                style={{bottom:"-20px"}}
                              >
                                {frmInitialValues[
                                  index
                                ]?.phoneNoError}
                              </div>
                            )}{" "}
                          {/* Display error message */}
                        </div>
                      </div>
                    </div>

                    <div className="tournament-playerdetail--wrap">
                      {/* <div className="tournament-caption-ingamename">
                        {/* {t("team_registration.in_game_name")} */}
                      {/* </div>  */}
                      <div className="tournament-player-ingamename-textfield">
                        <TextInput
                          labelName={t("team_registration.in_game_name")}
                          value={frmInitialValues[
                            index
                          ]?.inNameGame}
                          readOnly={ele?.isSubmit ? true : false}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )
          }
          )}
      </div>

      <div className="tournament-save-team">
        <button className="submit-button" disabled={isDisableJoinBtn} onClick={(e) => handleSave(e)}>
          {t("team_registration.save_team")}
        </button>
      </div>
      {isSubscriptionPopup && (
        <NonPremiumMaxJoinPopup
          isOpen={isSubscriptionPopup}
          message={t('premium.you_have_already_joined_today', { title: localStorage?.getItem("registerType") === "contest" ? "contest" : "tournament", total: localStorage?.getItem("registerType") === "contest" ? localStorage?.getItem('noOfContest') : localStorage?.getItem('noOfTournament') })}
          onClose={() => setSubscriptionPop(false)} title={"explore vi premium"}
          onSubscriptionBtnClick={() => { navigate('/more/subscription-pack') }} />
      )}

    </BaseHome>
  );
};

export default TeamRegistration;
